module.exports = __webpack_public_path__ + "img/build-spalling-hacking.d7bf0868.jpg";